import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest,
  DefaultApiCreatePurchaseApplicationRequest,
  DefaultApiCreatePurchaseApplicationTemplateRequest,
  DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest,
  DefaultApiDeletePurchaseApplicationTemplatesDetailRequest,
  DefaultApiGetPurchaseApplicationTemplatesDetailRequest,
  DefaultApiGetPurchaseApplicationsRequestedCountRequest,
  DefaultApiGetPurchaseApplicationsRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const createCategoryOfPurchaseApplicationTemplate = async (
  instance: AxiosInstance,
  {
    organizationId,
    createCategoryOfThePurchaseApplicationTemplateRequest,
  }: DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).createCategoryOfThePurchaseApplicationTemplate({
    createCategoryOfThePurchaseApplicationTemplateRequest,
    organizationId,
  })
}

export const createPurchaseApplication = async (
  instance: AxiosInstance,
  {
    organizationId,
    createPurchaseApplicationRequest,
    visaTransactionReferenceId,
  }: DefaultApiCreatePurchaseApplicationRequest
) => {
  return userApiDefaultApiFactory(instance).createPurchaseApplication({
    createPurchaseApplicationRequest,
    organizationId,
    visaTransactionReferenceId,
  })
}

export const createPurchaseApplicationTemplate = async (
  instance: AxiosInstance,
  {
    organizationId,
    createPurchaseApplicationTemplateRequest,
  }: DefaultApiCreatePurchaseApplicationTemplateRequest
) => {
  return userApiDefaultApiFactory(instance).createPurchaseApplicationTemplate({
    createPurchaseApplicationTemplateRequest,
    organizationId,
  })
}

export const deleteCategoryOfPurchaseApplicationTemplate = async (
  instance: AxiosInstance,
  {
    organizationId,
    purchaseTemplateCategoryId,
  }: DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).deleteCategoryOfThePurchaseApplicationTemplate({
    organizationId,
    purchaseTemplateCategoryId,
  })
}

export const deletePurchaseApplicationTemplatesDetail = async (
  instance: AxiosInstance,
  params: DefaultApiDeletePurchaseApplicationTemplatesDetailRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).deletePurchaseApplicationTemplatesDetail(params)
}

export const getApprovers = async (
  instance: AxiosInstance,
  { userAccountId }: { userAccountId: string }
) => {
  return userApiDefaultApiFactory(instance).getApprovers({ userAccountId })
}

export const getCategoriesOfPurchaseApplicationTemplate = async (
  instance: AxiosInstance,
  { organizationId }: { organizationId: string }
) => {
  return userApiDefaultApiFactory(
    instance
  ).getCategoryOfThePurchaseApplicationTemplate({
    organizationId,
  })
}

export const getPurchaseApplicationTemplates = async (
  instance: AxiosInstance,
  { organizationId }: { organizationId: string }
) => {
  return userApiDefaultApiFactory(instance).getPurchaseApplicationTemplates({
    organizationId,
  })
}

export const getPurchaseApplicationTemplatesDetail = async (
  instance: AxiosInstance,
  params: DefaultApiGetPurchaseApplicationTemplatesDetailRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).getPurchaseApplicationTemplatesDetail(params)
}

/**
 * @param {string} baseUrl
 * @param {string} userId
 */
export const getRequestedCount = async (
  instance: AxiosInstance,
  { userId }: DefaultApiGetPurchaseApplicationsRequestedCountRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).getPurchaseApplicationsRequestedCount({
    userId,
  })
}

export const getPurchaseApplications = async (
  instance: AxiosInstance,
  params: DefaultApiGetPurchaseApplicationsRequest
) => {
  return await userApiDefaultApiFactory(instance).getPurchaseApplications(
    params
  )
}

// Do Not Remove this line ===@import api client===
